import { ISavedOfferState } from '../types';

export const CHANGE_SAVED_OFFER = 'SAVED_OFFER :: CHANGE';

export type TChangeSavedOfferAction = {
  type: typeof CHANGE_SAVED_OFFER;
  payload: ISavedOfferState | null;
};

export function changeSavedOffer(payload: ISavedOfferState | null): TChangeSavedOfferAction {
  return {
    type: CHANGE_SAVED_OFFER,
    payload,
  };
}
